import React from 'react';
import { MenuItem, type MenuItemProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type NoneMenuItemProps = Omit<MenuItemProps, 'children'> & {
  value: '';
  ref?: React.Ref<HTMLLIElement>;
};

const NoneMenuItem = ({ value, ref, ...props }: NoneMenuItemProps) => (
  <MenuItem value={value} ref={ref} {...props}>
    <em>
      <FormattedMessage id="portfolio.challenge.select_field.options.none" />
    </em>
  </MenuItem>
);

export default NoneMenuItem;
